module.exports = __webpack_public_path__ + "static/media/view2.8c98f1bc.jpg";